import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    menu: {
        background: '#f8f8f8',
        '& input': {
            background: 'white',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
        '&:before': {
            height: 0,
        }
    },
    title: {
        fontWeight: 500,
        '&.Mui-expanded': {
            minHeight: 30,
        },
        '& > .MuiAccordionSummary-content': {
            fontSize: 13,
            margin: '10px 0 !important',
        }
    },
    wrapper: {
        background: 'white',
        flexDirection: 'column',
        padding: '20px 0',
    },
}, { name: 'SimpleAccordion' });

interface SimpleAccordionProps {
    title: string;
    children: any;
    defaultExpanded?: boolean;
    className?: string;
    expanded?: boolean;
}

export default function SimpleAccordion({ title, children, defaultExpanded = true, expanded, className = '' }: SimpleAccordionProps): JSX.Element {
    const classes = useStyles();

    return <>
        <Accordion className={[classes.menu, className].join(' ')} expanded={expanded} square={true} elevation={0} defaultExpanded={defaultExpanded}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
                className={classes.title}
            >
                {title}
            </AccordionSummary>
            <AccordionDetails className={classes.wrapper}>
                {children}
            </AccordionDetails>
        </Accordion>
    </>;
}
